import styled from 'styled-components';

const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 3rem;
  padding-top: 0.5rem;
`;

/* Franja amarilla vertical detrás del lockup */
const Stripe = styled.span`
  position: absolute;
  top: -1rem;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  width: 18px;
  background: ${({ theme }) => theme.colors.gold};
  z-index: 0;
`;

const Inner = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Kicker = styled.span`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: ${({ $onDark, theme }) => ($onDark ? '#f4f3ee' : theme.colors.text)};
  margin-bottom: 0.6rem;
`;

const Box = styled.div`
  border: 2px solid ${({ $onDark, theme }) => ($onDark ? '#f4f3ee' : theme.colors.text)};
  padding: 0.9rem 1.8rem 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
`;

const BigWord = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(1.6rem, 5vw, 2.6rem);
  font-weight: 800;
  letter-spacing: 0.18em;
  color: ${({ $onDark, theme }) => ($onDark ? '#ffffff' : theme.colors.text)};
  margin: 0;
`;

const SubRow = styled.span`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: ${({ $onDark, theme }) => ($onDark ? '#d8d5cc' : theme.colors.textMuted)};
`;

const SerifWord = styled.span`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: clamp(1.5rem, 4vw, 2.2rem);
  font-weight: 600;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: ${({ $onDark, theme }) => ($onDark ? '#ffffff' : theme.colors.text)};
  background: ${({ $onDark, theme }) => ($onDark ? 'transparent' : theme.colors.bg)};
  padding: 0 1rem;
  margin-top: -1.1rem;
  position: relative;
  z-index: 2;
`;

/*
 * Lockup de título de sección:
 *   [kicker]
 *   ┌───────────────┐
 *   │   BIG WORD    │
 *   │  sub · row    │
 *   └────  Serif ───┘
 */
function SectionHeading({ kicker, title, subtitle, serif, onDark = false }) {
  return (
    <Wrap>
      <Stripe aria-hidden="true" />
      <Inner>
        {kicker && <Kicker $onDark={onDark}>{kicker}</Kicker>}
        <Box $onDark={onDark}>
          <BigWord $onDark={onDark}>{title}</BigWord>
          {subtitle && <SubRow $onDark={onDark}>{subtitle}</SubRow>}
        </Box>
        {serif && <SerifWord $onDark={onDark}>{serif}</SerifWord>}
      </Inner>
    </Wrap>
  );
}

export default SectionHeading;
